module.exports = __webpack_public_path__ + "img/cta-home-bg-mobile.65088cc6.png";